// extracted by mini-css-extract-plugin
module.exports = {"container":"TimeIntervalsInfoBlob_container__kJ100"};